import get from 'lodash/get';
import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';

import { OPENTOK_TYPES } from './actions';
import { PUB_KEY, SCREEN_SHARING_VIDEO_TYPE } from '../helpers/constants';
import camelCaseKeys from '../../../utils/camelCaseKeys';

export const initialState = {
  loading: false,
  activeId: null,
  pinnedId: null,
  speakers: [],
  videoWarningIds: [],
  lastActiveSpeaker: null,
  connectionTime: null,
  durationData: {},
  connections: {},
  invitations: [],
};

export function reducer(state, { type, payload }) {
  switch (type) {
    case OPENTOK_TYPES.TOGGLE_LOADING: {
      return { ...state, loading: payload };
    }

    case OPENTOK_TYPES.SET_ACTIVE_ID: {
      return { ...state, activeId: payload };
    }

    case OPENTOK_TYPES.SET_START_CALL_TIME: {
      return { ...state, connectionTime: payload };
    }

    case OPENTOK_TYPES.SET_DURATION_DATA: {
      return { ...state, durationData: camelCaseKeys(payload) };
    }

    case OPENTOK_TYPES.SET_PIN: {
      const pinnedId = state.pinnedId === payload ? null : payload;
      return { ...state, pinnedId };
    }

    case OPENTOK_TYPES.FIND_SCREEN_SHARING: {
      const sharingConnection = Object.values(state.connections).find(
        connection =>
          get(connection, 'stream.videoType') === SCREEN_SHARING_VIDEO_TYPE,
      );

      const pinnedId = get(sharingConnection, 'id')
        ? get(sharingConnection, 'id')
        : null;

      return { ...state, pinnedId };
    }

    case OPENTOK_TYPES.ADD_SPEAKER: {
      return {
        ...state,
        speakers: [...state.speakers, payload],
        lastActiveSpeaker: payload,
      };
    }

    case OPENTOK_TYPES.REMOVE_SPEAKER: {
      return {
        ...state,
        speakers: state.speakers.filter(id => id !== payload),
      };
    }

    case OPENTOK_TYPES.ADD_VIDEO_WARNING_ID: {
      return {
        ...state,
        videoWarningIds: [...state.videoWarningIds, payload.id],
      };
    }

    case OPENTOK_TYPES.REMOVE_VIDEO_WARNING_ID: {
      return {
        ...state,
        videoWarningIds: state.videoWarningIds.filter(id => id !== payload.id),
      };
    }

    case OPENTOK_TYPES.ADD_CONNECTION: {
      let { activeId } = state;

      if (payload.id !== PUB_KEY && activeId === PUB_KEY) {
        activeId = payload.id;
      }

      return {
        ...state,
        activeId,
        connections: {
          ...state.connections,
          [payload.id]: { ...payload },
        },
      };
    }

    case OPENTOK_TYPES.UPDATE_CONNECTION: {
      const current = get(state, `connections[${payload.id}]`, {});
      return {
        ...state,
        connections: {
          ...state.connections,
          [payload.id]: {
            ...current,
            ...payload,
          },
        },
      };
    }

    case OPENTOK_TYPES.REMOVE_CONNECTION: {
      const { [payload.id]: toremove, ...connections } = state.connections;
      const pinnedId = payload.id === state.pinnedId ? null : state.pinnedId;
      const speakers = state.speakers.filter(id => id !== payload.id);
      const activeId = getActiveIdOnConnectionRemove(
        state.activeId,
        connections,
        payload,
      );

      return { ...state, connections, activeId, speakers, pinnedId };
    }

    case OPENTOK_TYPES.UPDATE_INVITATIONS: {
      return { ...state, invitations: payload };
    }

    case OPENTOK_TYPES.RESET: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
}

function getActiveIdOnConnectionRemove(activeId, connections, payload) {
  if (activeId === payload.id) {
    const { [PUB_KEY]: publisher, ...subscribers } = connections;
    return !isEmpty(subscribers) ? head(Object.keys(subscribers)) : PUB_KEY;
  }
  return activeId;
}



// WEBPACK FOOTER //
// ./src/redux/opentok/reducer/index.js